import { useMemo } from "react";
import { Select } from "@/components/ui/Select";
import { addMonths, formatPeriod, periodIdFromDate } from "@/lib/format";

interface Props {
  value: string;
  onChange: (periodId: string) => void;
}

export function PeriodSelector({ value, onChange }: Props) {
  const options = useMemo(() => {
    const today = periodIdFromDate(new Date());
    const future = Array.from({ length: 2 }, (_, i) => addMonths(today, i + 1));
    const past = Array.from({ length: 12 }, (_, i) => addMonths(today, -i));
    return [...future.reverse(), ...past];
  }, []);

  return (
    <Select id="period" value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((p) => (
        <option key={p} value={p}>
          {formatPeriod(p)}
        </option>
      ))}
    </Select>
  );
}
